<script lang="ts">
	import { GoBackIcon } from "../SVG";
	export let fill = "#6d6f76";
	export let hoverFill = "#5e8cf7";

	let mouseenter = false;

</script>

<button
	on:click
	on:mouseenter={() => (mouseenter = true)}
	on:mouseleave={() => (mouseenter = false)}>
	<GoBackIcon fill={mouseenter ? hoverFill : fill} />
</button>

<style lang="scss">
	button {
		width: 100%;
		height: 100%;
		border: none;
		background-color: transparent;
		padding: 0;
		margin: 0;

		&:hover {
			cursor: pointer;
		}
	}

</style>
